import { useEffect, useState } from "react";
import DeleteControl from './DeleteControl';
import UploadVideoForm from './UploadVideoForm';
import { auth } from '../firebase';
import { signOut, onAuthStateChanged } from "firebase/auth";
import { Helmet } from "react-helmet-async";

const AdminControls = ({ videos = [], onUploadVideo, onDeleteVideo }) => {
  const [checkingAuth, setCheckingAuth] = useState(true);

  // 🔐 管理者認証チェック（匿名・他プロバイダは即ログアウト）
  useEffect(() => {
    const unsubscribe = onAuthStateChanged(auth, (user) => {
      const provider = user?.providerData?.[0]?.providerId;
      if (!user?.uid || user.isAnonymous || provider !== 'password') {
        // 🚫 匿名 or 他ログイン方法 → 強制ログアウト
        signOut(auth).finally(() => {
          window.location.href = '/';
        });
      } else {
        // ✅ 管理者（メール＋パスワード）のみ通過
        setCheckingAuth(false);
      }
    });
    return () => unsubscribe();
  }, []);

  // 🔓 明示的なログアウト操作
  const logout = async () => {
    try {
      await signOut(auth);
    } finally {
      window.location.href = '/';
    }
  };

  // アップロード済み動画一覧を描画
  const renderItemList = (items = [], itemType, onDelete) => {
    if (!Array.isArray(items) || items.length === 0) {
      return <p style={styles.message}>アップロードされた{itemType}がまだありません。</p>;
    }
    return items.map((item, index) => (
      <div key={index} style={styles.item}>
        <p style={styles.videoTitle}>{item.name}</p>
        <DeleteControl
          itemType={itemType}
          itemName={item.name}
          itemPath={`videos/${item.name}`}
          onDeleteSuccess={() => onDeleteVideo?.(item.name)}
        />
      </div>
    ));
  };

  // 認証中はチラ見え防止
  if (checkingAuth) {
    return (
      <>
        <Helmet>
          <title>管理画面 | New-Nightlife</title>
          <meta name="robots" content="noindex, nofollow" />
          <meta name="googlebot" content="noindex, nofollow" />
          <link rel="canonical" href="https://new-nightlife.jp/admin" />
        </Helmet>
        <div style={{ padding: "5vw", textAlign: "center", color: "#666" }}>
          認証確認中…
        </div>
      </>
    );
  }

  return (
    <>
      <Helmet>
        <title>管理画面 | New-Nightlife</title>
        <meta name="robots" content="noindex, nofollow" />
        <meta name="googlebot" content="noindex, nofollow" />
        <link rel="canonical" href="https://new-nightlife.jp/admin" />
      </Helmet>

      <div style={styles.container}>
        <div style={styles.header}>
          <h3 style={styles.title}>🔐 管理者モード</h3>
          <button onClick={logout} style={styles.logoutButton}>ログアウト</button>
        </div>

        <div style={styles.formArea}>
          <UploadVideoForm onUploadComplete={onUploadVideo} />
        </div>

        <div style={styles.listSection}>
          <h4 style={styles.subtitle}>🎥 アップロード済み動画</h4>
          {renderItemList(videos, '動画', onDeleteVideo)}
        </div>
      </div>
    </>
  );
};

// 💄 スタイル定義
const styles = {
  container: {
    margin: "5vw",
    padding: "5vw",
    fontFamily: "'M PLUS Rounded 1c', sans-serif",
    background: "linear-gradient(to bottom right, #263238, #37474F)",
    color: "#fff",
    borderRadius: "12px",
    boxShadow: "0 4px 12px rgba(0, 0, 0, 0.3)",
  },
  header: {
    display: "flex",
    flexDirection: 'column',
    gap: '10px',
    justifyContent: "center",
    alignItems: "center",
    marginBottom: "20px",
  },
  title: {
    fontSize: "5vw",
    fontWeight: "bold",
    color: "#FFCDD2",
  },
  logoutButton: {
    padding: "10px 24px",
    backgroundColor: "#FF5252",
    color: "#fff",
    border: "none",
    borderRadius: "6px",
    cursor: "pointer",
    fontWeight: "bold",
    fontSize: '4vw',
  },
  formArea: {
    backgroundColor: "#455A64",
    padding: "5vw",
    borderRadius: "8px",
    boxShadow: "inset 0 0 10px rgba(255,255,255,0.1)",
    marginBottom: "24px",
  },
  listSection: {
    marginTop: "20px",
    padding: "4vw",
    backgroundColor: "#546E7A",
    borderRadius: "8px",
  },
  item: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    marginBottom: "10px",
    backgroundColor: "#607D8B",
    padding: "10px",
    borderRadius: "6px",
    flexWrap: 'wrap',
  },
  videoTitle: {
    fontSize: "4vw",
    color: "#FFF",
    flexGrow: 1,
    marginBottom: '4px',
  },
  message: {
    fontSize: "14px",
    color: "#CFD8DC",
  },
  subtitle: {
    fontSize: "4.5vw",
    fontWeight: "bold",
    marginBottom: "10px",
    color: "#FFEBEE",
  },
};

export default AdminControls;
